// A tab left open across a web deploy still runs the old build, whose lazy chunks
// (including every Capacitor plugin's `import("./web")`) have been replaced by new hashes.
// The first lazy import after the deploy 404s with "Failed to fetch dynamically imported
// module". Reloading picks up the new index.html and its chunk names.
//
// Reload at most once per window so a genuinely missing chunk can't loop the page; on the
// second failure the error is left unprevented and reaches Sentry as before.

const LAST_RELOAD_KEY = "staleChunkReloadAt";
const RELOAD_WINDOW_MS = 30_000;

const readLastReload = (): number => {
  try {
    return Number(sessionStorage.getItem(LAST_RELOAD_KEY)) || 0;
  } catch {
    return 0;
  }
};

const markReload = (now: number): boolean => {
  try {
    sessionStorage.setItem(LAST_RELOAD_KEY, String(now));
    return true;
  } catch {
    return false;
  }
};

window.addEventListener("vite:preloadError", (event) => {
  const now = Date.now();
  if (now - readLastReload() < RELOAD_WINDOW_MS) return;
  // Without storage there is no loop guard, so don't reload at all.
  if (!markReload(now)) return;
  event.preventDefault();
  window.location.reload();
});
